import type Location from '@/data/location/model';
import { withMatcher } from '@/shared/util/withMatcher';
import { SET_TODAYS_SCHEDULE_LOCATION_ID } from '@/store/action-types';

export const setTodaysScheduleLocationId = withMatcher((scheduleId: Location['id']) => ({
  payload: scheduleId,
  type: SET_TODAYS_SCHEDULE_LOCATION_ID,
}));
